import { css, ElementStyles } from '@microsoft/fast-element';
import { zeroSegmentedItemStyles } from '@genesislcap/foundation-zero';
import { ElementDefinitionContext, FoundationElementDefinition } from '@microsoft/fast-foundation';
import { boxSizing } from '../../../styles';

export const customSegmentedItemStyles = (
  context: ElementDefinitionContext,
  definition: FoundationElementDefinition
): ElementStyles => css`
  ${zeroSegmentedItemStyles(context, definition)}
  ${boxSizing}
  :host span {
    white-space: nowrap;
  }
`;
